// NPM Imports
import React, { Fragment, Component } from "react";
// import PropTypes from "prop-types";
// import { Button } from "../../../../revvComponents";

// // Internal Imports
// import withRbac from "../../../../app/withRbac";
// import { PERMISSIONS } from "../../../../constants";
// import TemplateHeaderSearch from "./TemplateHeaderSearch";
import PlanUpgrade from "../../../PlanUpgrade";

// Destructuring
class FieldsListingHeader extends Component {
  state = {
    showCreateTemplatePopUp: false,
  };

  _toggleTemplatePopUp = () => {
    this.setState(prevState => ({
      showCreateTemplatePopUp: !prevState.showCreateTemplatePopUp,
    }));
  };

  render() {
    // CREATE BTN DISPLAY BASED ON RBAC
    // const ImportDataBtn = withRbac(() => (
    //   <Button
    //     data-test="listdoctemplates-create-new-template-button"
    //     className="createdropdown-btn"
    //     onClick={this._toggleTemplatePopUp}>
    //     Import Data
    //   </Button>
    // ));
    // const { type, showSearchPage, toggleSearchPage, togglePreview } =
    //   this.props;
    return (
      <Fragment>
        <div className="fields-header-container">
          {/* SEARCH BAR SECTION */}
          <div className="fields-header-title-wrapper">
            <div className="fields-header-title">My Fields</div>
            <div className="fields-header-subtitle">
              Manage Revv Form Fields and their connections here
            </div>
          </div>
          {/** CREATE TEMPLATE BTN SECTION */}
          {/* <div className="create-container">
            <ImportDataBtn
              permission={PERMISSIONS.TEMPLATES.UPDATE_TEMPLATES}
            />
          </div> */}
          <div style={{ marginLeft: 10 }}>
            <PlanUpgrade showOnlyOnFreePlan templateBtn />
          </div>
        </div>
      </Fragment>
    );
  }
}

export default FieldsListingHeader;
